import * as Yup from "yup";
import { campo_obligatorio } from "../../utils/traductor";

export function initialValues(state) {
  return {
    EmpresaId: "",
  };
}

export function validationSchema() {
  return Yup.object({
    EmpresaId: Yup.string().required(` ${campo_obligatorio} `),
  });
}
